export enum EnvironmentName {
  Preproduction = "preproduction",
  ReviewApp = "review-app",
}

export type EnvironmentState = {
  env: EnvironmentName;
  reviewAppBranchName: string;
};

export type EnvironmentActions = {
  setEnv: (env: EnvironmentName, branchName?: string) => void;
  reset: () => void;
  getApiUrl: () => string;
  getFrontendUrl: () => string | null;
};
